import { MarginProps } from '../../../../page-builder/puck/reusable-props/margin';
import './styles.scss';
import { ComponentConfig, DropZone } from '@measured/puck';
import {
  GapProps,
  gapField,
} from '../../../../page-builder/puck/reusable-props/gap';
import {
  flexDirections,
  boxShadows,
  verticalAligns,
} from '../../../../page-builder/puck/reusable-props/options';
import { PaddingProps } from '../../../../page-builder/puck/reusable-props/padding';
import CustomTooltip from '../../../../components/common/tooltip';
import { ReduxSelectorProps } from '../../../services/constants';
import InputField from '../../../../components/common/input-field';
import { FieldLabel } from '@measured/puck';
import {
  getNewCurrentDeviceType,
  getNumberPatternWithAuto,
} from '../../../utils/helper';
import {
  getBorderProps,
  getcurrentDeviceType,
  getMarginStyles,
  getPaddingStyles,
  resolveShowComponentField,
} from '../../../utils/helper';
import showComponent, {
  showComponentProps,
} from '../../../puck/reusable-props/showComponent';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../../puck/reusable-props/Border';
import { useEffect, useRef } from 'react';
import WidthComponent, { IWidthComponentProps } from '../widthComponent';
import JustifyContent, {
  justifyContentProps,
  IJustifyContentProps,
} from './justify-content';
import { backgroungFields } from '../../../puck/reusable-props/backgroungFields';
import { IAsset } from '../../../interface/apiServiceInterface';
import { imageField } from '../../../puck/reusable-props/image';
import { AxiosInstance } from 'axios';
import {
  backgroundImageProps,
  BackgroudImageProps,
} from '../../../puck/reusable-props/background-image-props';
import MarginComponent from '../../customComponents/MarginComponent';
import PaddingComponent from '../../customComponents/PaddingComponent';
export interface SimplePageComponentProps extends ReduxSelectorProps {
  baseService: AxiosInstance;
}

export interface ContainerProps
  extends MarginProps,
    GapProps,
    PaddingProps,
    BackgroudImageProps,
    showComponentProps {
  background: {
    color: string;
    isInherit: boolean;
  };
  backgroundImageFile: IAsset;
  height: string;
  border: IBorderValueProps;
  justifyContent: IJustifyContentProps;
  flexDirection: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  boxShadow: 'none' | 'shadow-md' | 'shadow-lg' | 'shadow-xl' | 'shadow-2xl';
  verticalAlign:
    | 'justify-start'
    | 'justify-center'
    | 'justify-end'
    | 'justify-stretch';
  position: string;
  zIndex: string;
  width: IWidthComponentProps;
  maxWidth: IWidthComponentProps;
}

export const Container = ({
  useAppSelector,
  baseService,
}: ReduxSelectorProps & {
  baseService: AxiosInstance;
}): ComponentConfig<ContainerProps> => {
  return {
    label: (
      <CustomTooltip title="Container">
        <span>Container</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      margin: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <MarginComponent
            value={value}
            onChange={onChange}
            title="Margin"
            extraFields={true}
          />
        ),
      },
      padding: {
        type: 'custom',
        label: 'Padding',
        render: ({ value, onChange }) => (
          <PaddingComponent
            value={value}
            onChange={onChange}
            title="Padding"
            extraFields={true}
          />
        ),
      },

      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border
            value={value}
            onChange={onChange}
            title="Border"
            showWidthProps={true}
          />
        ),
      },
      ...backgroungFields,
      justifyContent: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <JustifyContent
            value={value}
            onChange={onChange}
            title="Justify Content"
          />
        ),
      },
      backgroundImageFile: { ...imageField(false, baseService).file },
      ...backgroundImageProps([]),
      width: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <WidthComponent onChange={onChange} value={value} />
        ),
      },
      maxWidth: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <WidthComponent onChange={onChange} value={value} title="Max width" />
        ),
      },
      position: {
        type: 'radio',
        options: [
          { label: 'Sticky', value: 'sticky-container' },
          { label: 'None', value: '' },
        ],
      },
      zIndex: {
        type: 'radio',
        label: 'Z-Index',
        options: [
          { label: 'Front', value: 'z-10' },
          { label: 'Back', value: '' },
        ],
      },
      flexDirection: {
        label: 'Direction',
        type: 'select',
        options: flexDirections,
      },
      boxShadow: {
        label: 'Shadow',
        type: 'select',
        options: boxShadows,
      },
      verticalAlign: {
        label: 'Vertical Align',
        type: 'select',
        options: verticalAligns,
      },
      ...gapField,
      height: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <FieldLabel
            label={
              (
                <CustomTooltip title="Height">
                  <span>Height</span>
                </CustomTooltip>
              ) as React.ReactNode as string
            }>
            <InputField
              value={value}
              onChange={e => {
                const newValue = getNumberPatternWithAuto(e);
                if (newValue !== null) {
                  onChange(newValue);
                }
              }}
            />
          </FieldLabel>
        ),
      },
    },
    defaultProps: {
      showComponent: ['desktop', 'tablet', 'mobile'],
      maxWidth: {
        deviceType: 'desktop',
        width: {
          desktop: 'none',
          tablet: 'none',
          mobile: 'none',
        },
      },
      position: '',
      zIndex: '',
      flexDirection: 'row',
      background: {
        color: '#ffffff',
        isInherit: false,
      },
      width: {
        deviceType: 'desktop',
        width: {
          desktop: '100%',
          tablet: '100%',
          mobile: '100%',
        },
      },
      ...borderProps,
      ...justifyContentProps,
      margin: {
        desktop: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        doubleXL: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        tripleXL: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
      },
      backgroundImageFile: {
        storeID: '',
        fileName: 'background',
        imageUrl: '',
      },
      bg_image: {
        backgroundPosition: 'bg-center',
        backgroundRepeat: 'bg-no-repeat',
        backgroundSize: 'bg-cover',
      },
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
          doubleXL: '0',
          tripleXL: '0',
        },
        paddingLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
          doubleXL: '0',
          tripleXL: '0',
        },
        paddingRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
          doubleXL: '0',
          tripleXL: '0',
        },
        paddingTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
          doubleXL: '0',
          tripleXL: '0',
        },
      },
      gap: 'gap-2',
      height: '128',
      boxShadow: 'none',
      verticalAlign: 'justify-start',
    },
    resolveFields: ({ props }, { fields }) =>
      resolveShowComponentField(props.id, fields),
    render: ({
      position,
      zIndex,
      background,
      border,
      margin,
      padding,
      gap,
      backgroundImageFile,
      bg_image,
      height,
      flexDirection,
      boxShadow,
      verticalAlign,
      showComponent,
      width,
      justifyContent,
      maxWidth,
      editMode,
      id,
    }) => {
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const newCurrentDeviceType = getNewCurrentDeviceType(
        windowWidth,
        editMode,
      );
      const marginStyles = getMarginStyles(margin, newCurrentDeviceType);
      const observerRef = useRef<MutationObserver | null>(null);

      useEffect(() => {
        const iframe = document.getElementById(
          'preview-frame',
        ) as HTMLIFrameElement;
        const hasViewScrollbar =
          document?.documentElement.scrollHeight >
          document?.documentElement.clientHeight;
        const viewHeight = document?.querySelector('.dropzone-height');
        if (hasViewScrollbar && viewHeight) {
          (viewHeight as HTMLElement).style.removeProperty('height');
        } else if (viewHeight) {
          (viewHeight as HTMLElement).style.height = '100vh';
        }
        const checkScroll = () => {
          if (iframe?.contentDocument) {
            const hasScrollbar =
              iframe?.contentDocument.documentElement.scrollHeight >
              iframe?.contentDocument.documentElement.clientHeight;
            const iframeDocument =
              iframe.contentDocument || iframe.contentWindow?.document;
            const dropzoneHeight =
              iframeDocument?.querySelector('.dropzone-height');
            const frameRootDiv = iframeDocument?.getElementById('frame-root');

            if (hasScrollbar && dropzoneHeight) {
              (dropzoneHeight as HTMLElement).style.removeProperty('height');
            } else if (frameRootDiv && dropzoneHeight) {
              (dropzoneHeight as HTMLElement).style.height = '100vh';
            }
          }
        };
        observerRef.current = new MutationObserver(checkScroll);
        observerRef.current.observe(document.body, {
          childList: true,
          subtree: true,
        });
        window.addEventListener('resize', checkScroll);

        setTimeout(() => {
          if (iframe?.contentDocument) {
            const childDiv = iframe?.contentDocument?.querySelector(
              `div[data-puck-component='${id}']`,
            ) as HTMLElement;
            if (childDiv) {
              if (isNaN(+height)) {
                childDiv.style.height = editMode ? height : 'inherit';
              } else {
                childDiv.style.removeProperty('height');
              }
            }
          }
        }, 100);
      }, [height]);
      let finalWidth: string;
      if (width?.width?.[currentDeviceType]?.includes('%')) {
        finalWidth = width?.width?.[currentDeviceType];
      } else if (width?.width?.[currentDeviceType]) {
        finalWidth = `${width?.width?.[currentDeviceType]}px`;
      } else {
        finalWidth = '100%'; // handled for BC
      }
      let finalMaxWidth: string;
      if (maxWidth?.width?.[currentDeviceType]?.includes('%')) {
        finalMaxWidth = maxWidth?.width?.[currentDeviceType];
      } else if (maxWidth?.width?.[currentDeviceType]) {
        finalMaxWidth = `${maxWidth?.width?.[currentDeviceType]}px`;
      } else {
        finalMaxWidth = 'none'; // handled for BC
      }

      const backgroundUrl = backgroundImageFile?.imageUrl
        ? process.env.REACT_APP_S3_BUCKET_URL + backgroundImageFile.imageUrl
        : '';

      return (
        <div
          className={`Container flex ${justifyContent?.justify?.[currentDeviceType]} ${gap} ${position} ${boxShadow} ${border?.borderStyle?.[currentDeviceType]} ${zIndex} ${showComponent?.includes(currentDeviceType) ? '' : '!hidden'}`}
          style={{
            ...getBorderProps(border, currentDeviceType, true),
            backgroundColor: background?.isInherit
              ? 'inherit'
              : background?.color,
            flexDirection,
            ...marginStyles,
            height: editMode
              ? isNaN(+height)
                ? '100%'
                : +height
              : isNaN(+height)
                ? height
                : +height,
            ...getPaddingStyles(padding, newCurrentDeviceType),
          }}>
          <DropZone
            className={`${bg_image?.backgroundRepeat} flex ${verticalAlign} flex-col ${position ? position + ' !h-fit' : ''}
              ${bg_image?.backgroundSize} ${bg_image?.backgroundPosition}`}
            zone={`Container`}
            style={{
              backgroundImage: `url(${backgroundUrl})`,
              width: finalWidth,
              maxWidth: finalMaxWidth,
            }}
          />
        </div>
      );
    },
  };
};
